import React from "react";
import "./Viewer.css";
import promptActions from "./data/promptActions.json";
import { useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "@google/model-viewer";
import {
    IS_WEBXR_AR_CANDIDATE,
    IS_SCENEVIEWER_CANDIDATE,
    IS_AR_QUICKLOOK_CANDIDATE,
} from "@google/model-viewer/lib/constants";

import { getPromptMode, getPromptShowcase, setARMode, setPromptMode } from "../redux_store/appState";
import { APP_JOB, APP_MODEL } from "../AppConfig";
import { BaseURL } from "../../components/Common";

// AR modes
export const MODE_WEBXR = "webxr";
export const MODE_SCENE_VIEWER = "scene-viewer";
export const MODE_QUICK_LOOK = "quick-look";

// Prompt modes
export const PROMPT_ROTATE = 0;
export const PROMPT_ZOOM = 1;
export const PROMPT_PAN = 2;

/**
 * Generates the <model-viewer>.
 * @param {object} props props.height sets the height of the mode-viewer in it's container
 * @returns model-viewer
 */
export function Viewer(props) {
    // Refs to refer back to in useEffect
    const viewer = useRef(null);
    const finger0 = useRef(null);
    const finger1 = useRef(null);

    // Current state of the interaction prompt
    const promptModeInitial = useSelector(getPromptMode); //initial mode
    const showcase = useSelector(getPromptShowcase); //auto-scrolling showcase

    const dispatch = useDispatch();

    // Set-up that requires model-viewer to be loaded happens in useEffect
    useEffect(() => {
        /**
         * Sest the AR Mode once the model-viewer exists.
         * @param {object} event onLoad event
         */
        const onLoad = (event) => {
            // let arMode = "";
            // if (event.target.canActivateAR) {
            //     if (IS_WEBXR_AR_CANDIDATE) {
            //         arMode = MODE_WEBXR;
            //     } else if (IS_SCENEVIEWER_CANDIDATE) {
            //         arMode = MODE_SCENE_VIEWER;
            //     } else if (IS_AR_QUICKLOOK_CANDIDATE) {
            //         arMode = MODE_QUICK_LOOK;
            //     }
            // }
            // if (!arMode) {
            //     finger0.current.style.display = "block";
            //     finger1.current.style.display = "block";
            // }
            // dispatch(setARMode(arMode));
            // 
        };

        // Interaction prompt timing for auto-scrolling showcase
        const PROMPT_MS = 5000;
        const PROMPT_REPEAT_MS = 6000;

        let stop = false; //flag to stop interaction prompts

        /**
         * Increments the prompt mode during auto-scrolling showcase
         */
        const nextPrompt = () => {
            if (!stop) {
                dispatch(setPromptMode((promptModeInitial + 1) % (PROMPT_PAN + 1)));
            }
        };

        /**
         * Stops the interaction prompt when the user interacts with the model.
         * @param {object} event camera-change event
         */
        const interacted = (event) => {
            if (event.detail.source === "user-interaction") {
                stop = true;
            }
        };

        /**
         * Triggers a synthetic interaction prompt and queues up the next prompt.
         */
        const prompt = () => {
            if (!stop) {
                viewer.current.interact(
                    PROMPT_MS,
                    promptActions[promptModeInitial].finger0,
                    promptActions[promptModeInitial].finger1
                );
                if (showcase) {
                    setTimeout(nextPrompt, PROMPT_REPEAT_MS);
                } else {
                    setTimeout(prompt, PROMPT_REPEAT_MS);
                }
            }
        };

        const elem = viewer.current; //model-viewer

        // Add event listeners now that model-viewer exists
        elem.addEventListener("load", onLoad); //sets up ar mode
        elem.addEventListener("camera-change", interacted); //captures user interaction
        const loaded = elem.modelIsVisible;
        if (loaded) {
            //If the model is loaded we don't need to wait for the event
            prompt();
        } else {
            //Start the interaction prompt once the model is visible
            elem.addEventListener("poster-dismissed", prompt, { once: true });
        }

        return () => {
            stop = true; //stop the loop

            // Remove the event handlers
            elem.removeEventListener("load", onLoad);
            elem.removeEventListener("camera-change", interacted);
            if (!loaded) {
                elem.removeEventListener("poster-dismissed", prompt);
            }
        };
    }, [dispatch, promptModeInitial, showcase]);

    return (
        <model-viewer
            ref={viewer}
            id="model-view"
            preload
            style={{ height: props.height }}
            camera-controls
            camera-orbit="45deg 55deg auto"
            touch-action="pan-y"
            interaction-prompt="none"
            src={APP_MODEL}
            alt={`AR Viewer - ${APP_JOB}`}
        >
            {/* <button slot="ar-button">Enter AR Mode</button>
            <img
                ref={finger0}
                style={{ display: "none" }}
                src={BaseURL("images/touch.svg")}
                slot="finger0"
                alt="Left finger"
            ></img>
            <img
                ref={finger1}
                style={{ display: "none" }}
                src={BaseURL("images/touch.svg")}
                slot="finger1"
                alt="Right finger"
            ></img> */}
        </model-viewer>
    );
}
